// Copyright © 2021 Move Closer
import { TokenType } from '@d24/demarked';
import { getModuleBase } from '../_helpers/adapter';
import { ModuleDriver } from '../_contracts';
import { AdBannerSize, AdBannerType, AdBannerVersion } from './AdBanner.contracts';
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export class AdBannerAdapter {
    /**
     * @inheritDoc
     */
    objectToToken() {
        return {
            content: '$$$',
            raw: '$$$',
            type: TokenType.AdBanner
        };
    }
    /**
     * @inheritDoc
     */
    tokenToObject() {
        return {
            ...getModuleBase(),
            content: {
                autoFetchSiteTags: true,
                doNotShrink: false,
                sizes: [],
                size: AdBannerSize.InText,
                type: AdBannerType.Default
            },
            driver: ModuleDriver.AdBanner,
            version: AdBannerVersion.GoogleAds
        };
    }
}
